var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { staticClass: "w-100" },
        [
          _vm.holdingEnterprises.length === 0
            ? _c("h5", { staticClass: "text-center" }, [
                _vm._v(" No hay datos ")
              ])
            : _c("b-table", {
                attrs: {
                  busy: _vm.loading,
                  items: _vm.holdingEnterprises,
                  fields: _vm.fields
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(see_details)",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c("vs-icon", {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: "Ver detalle",
                                  expression: "'Ver detalle'"
                                }
                              ],
                              staticClass: "cursor-pointer",
                              attrs: { icon: "assessment", size: "small" },
                              on: {
                                click: function($event) {
                                  return _vm.showDetails(item.iut)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    }
                  },
                  {
                    key: "cell(totalHistoricalWeight)",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " + _vm._s(item.totalHistoricalWeight) + " MB "
                        )
                      ]
                    }
                  }
                ])
              })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }